import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { StringUtils } from '../../utils';
import { Routes as routes } from '../../navigation';
import { UserActions, NavigationActions, ContextActions, PracticeActions, ToastActions } from '../../actions';
import { SwitchAccount, TitleBar, NavBar, SingleScreenNavBar } from  '../../components'

class PracticeAssignClientScreen extends Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }

  renderAssignClientSection = (client, location) => {

    if (!client || !location) {
      return null;
    }

    const clientInfo = client.user_details && client.user_details[0] ? client.user_details[0] : {};
    const providersAtLocation  = this.getProvidersAtLocation(location);
    const locationHasProviders = providersAtLocation.length > 0 ? true : false;

    const providerRows = providersAtLocation.map((provider) => {
      return <div key={provider._id} className='flex-container-row' style={{ justifyContent: 'space-between', width: '100%', alignItems: 'center', marginBottom: 2 }}>
        <span style={{ fontSize: 16 }}>{ StringUtils.displayName(provider) }</span>
        <input type='submit'
               className='button-clear-blue'
               value='Assign'
               onClick={ () => {
                 const token = this.props.user.auth.token;
                 const createNewObj = client.has_selected_provider === '' ? true : false;
                 const userProviderObject = {
                   _id: client._id || '',
                   user_id: clientInfo._id,
                   practice_id: client.practice_id,
                   provider_id: provider._id,
                   provider_location: client.provider_location,
                   has_selected_provider: 'SELECTED',
                 }

                 // if (createNewObj) {
                 //   this.props.practiceActions.addClientUserProvider(token, userProviderObject, this.successAction);
                 // } else {
                   this.props.practiceActions.updateClientUserProvider(token, userProviderObject, this.successAction);
                 // }
               }}
        />
      </div>
    })

    return <div className="flex-container screen-main-content">
      <div className="screen-container-column">
        <div className="basic-container">

          <div className='flex-container-column' style={{  alignItems: 'center' }}>

            <div className='flex-container-row' style={{ marginTop: 5 }}>
              { clientInfo.photo_url ? <img className="image-default" src={clientInfo.photo_url} style={{ height: 60, width: 60, borderRadius: 30 }}/>
              : <span className="fas fa-user-circle" style={{ fontSize: 60, color: '#e9e9e9' }}></span> }
              <div className='flex-container-column' style={{ marginLeft: 10, justifyContent: 'center' }}>
                <span style={{ fontSize: 18 }}>{ StringUtils.displayName(clientInfo) }</span>
                <span style={{ fontSize: 16, color: 'grey', marginTop: -5 }}>{ location.name ? location.name : location.street_address }</span>
              </div>
            </div>

            { !locationHasProviders ? null
            : <div className='flex-container-column' style={{  alignItems: 'center', marginTop: 15 }}>
                <div style={{ fontSize: 20, marginBottom: 5 }}>Providers at { location.name ? location.name : location.street_address }</div>
                { providerRows }
              </div>
            }


          </div>

        </div>
      </div>
    </div>
  }

  render() {

    const client    =  this.props.practice && this.props.practice.selectedUnassignedClient ? this.props.practice.selectedUnassignedClient : {};
    const location  =  this.props.practice
                      && this.props.practice.locations
                      && this.props.practice.locations[client.provider_location] ? this.props.practice.locations[client.provider_location] : null;

    return (
      <div className="flex-container flex-container-column flex-center-align">
        <TitleBar
          selectedPractice={this.props.context.selectedPractice}
          selectedRole={this.props.context.selectedRole}
          practices={this.props.user.practices}
          userActions={this.props.userActions}
          practice={this.props.practice.practice}
        />
        <SingleScreenNavBar title={'Assign a Provider to this Client'} />
        { this.renderAssignClientSection(client, location) }
      </div>
    );
  }

  getProvidersAtLocation = (location) => {
    var providers = [];
    if (!location.members || location.members.length === 0) {
      return providers;
    }

    location.members.forEach((member) => {
      const memberInfo  = member.user_details && member.user_details[0] ? member.user_details[0] : null;
      const memberRoles = member.user_roles   && member.user_roles[0]   ? member.user_roles[0]   : null;
      if (memberInfo && memberRoles && (memberRoles.vet === true || memberRoles.behaviorist === true)) {
        providers.push(memberInfo);
      }
    })

    return providers;
  }

  successAction = () => {
    this.props.toastActions.displayInfo('Provider assigned to Client');
    NavigationActions.navigateBack();
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    context: state.context,
    practice: state.practice,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    contextActions: bindActionCreators(
     { ...ContextActions }, dispatch),
    practiceActions: bindActionCreators(
     { ...PracticeActions }, dispatch),
    toastActions: bindActionCreators(
     { ...ToastActions }, dispatch),
    userActions: bindActionCreators(
     { ...UserActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PracticeAssignClientScreen)
